import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import Title from "../../components/Title";
import MetaConnectButton from "../../components/MetaConnectButton";
import useMetaEmbeddedSignup from "../../hooks/useMetaEmbeddedSignup";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3),
    maxWidth: 560,
    margin: "40px auto",
  },
  actions: {
    marginTop: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
}));

const WabaSignup = () => {
  const classes = useStyles();
  const history = useHistory();
  const { isAuth } = useContext(AuthContext);
  const { connecting, startEmbeddedSignup, loading, enabled, sdkReady } =
    useMetaEmbeddedSignup({
      onSuccess: () => {
        history.push("/connections");
      },
    });

  useEffect(() => {
    if (!isAuth) {
      history.push("/login");
    }
  }, [isAuth, history]);

  if (!isAuth) {
    return (
      <Box display="flex" justifyContent="center" mt={8}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <MainContainer>
      <Paper className={classes.paper} variant="outlined">
        <Title>{i18n.t("connections.meta.signupTitle")}</Title>
        <Typography variant="body1" paragraph>
          {i18n.t("connections.meta.signupInstructions")}
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          {i18n.t("connections.meta.coexistenceHint")}
        </Typography>
        <Typography variant="caption" color="textSecondary" paragraph>
          Permita popups para este site. O Facebook SDK carrega no padrão oficial
          (FB.init + cookie + getLoginStatus). Use o botão abaixo nesta página
          (/waba-signup).
          {sdkReady ? " SDK pronto." : " Carregando SDK…"}
        </Typography>
        <div className={classes.actions}>
          <MetaConnectButton
            connecting={connecting || loading}
            disabled={(!enabled && !loading) || connecting}
            onClick={startEmbeddedSignup}
          />
        </div>
      </Paper>
    </MainContainer>
  );
};

export default WabaSignup;
